import { lazy } from "react";

const Administration = [
  {
    exact: true,
    path: "/admin/backups/topics-deleted/:name",
    acl: "topics_backup",
    component: lazy(() =>
      import(
        "@src/views/BackOffice/smartend/topicList/deletedTopics/DeletedTopics"
      )
    ),
  },
  {
    path: "/admin/backups/rushs",
    acl: "rush_backup",
    component: lazy(() =>
      import(
        "@src/views/BackOffice/planning/rush/rushs/softdeleted/SoftDeletedRushs"
      )
    ),
  },
  {
    path: "/admin/backups/episode",
    acl: "episode_backup",
    component: lazy(() =>
      import(
        "@src/views/BackOffice/planning/episodes/backupEpisode/SoftDeletedEpisodes"
      )
    ),
  },
];

export default Administration;
